export default __webpack_public_path__ + "static/media/incubator4.e22e57df.jpg";